module.exports = __webpack_public_path__ + "fonts/Raleway-ExtraBoldItalic.9054c2a1.woff2";